export default function CloseIcon() {
  return (
    <svg
      width="9"
      height="8"
      viewBox="0 0 9 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.2 0.727L0.926 0 8.2 7.273 7.472 8 0.2 0.727Z"
        fill="#999999"
      />
      <path
        d="M0.926 8 0.2 7.273 7.472 0 8.2 0.727 0.926 8Z"
        fill="#999999"
      />
    </svg>
  );
}
